import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import UserUtils from 'utils/user-utils';
import TimeUtils from 'utils/time';
import dayjs from 'utils/dayjs-timezone';
import getUserLocation from '../utils/user-location';
import ReservationUtils from 'utils/reservation-utils';
import getReservationStatus from 'segment/utils/reservation-status';

export default function trackParkingPassClick({
    reservation,
    user,
    clickTarget,
    isReservationChange,
    activeStatus,
}) {
    try {
        const now = dayjs();
        const {email, isAdmin, status} = user;
        const {
            starts,
            ends,
            timezone,
            reservationType,
            city,
            facility,
            currencyType,
            event,
            rentalId,
            entryTimestamp,
            exitTimestamp,
            paymentStatus,
        } = reservation;
        const isMonthly =
            reservationType === ReservationUtils.RESERVATION_TYPES.MONTHLY;
        const reservationStatus = getReservationStatus({
            activeStatus,
            paymentStatus,
        });

        const properties = {
            admin_user: isAdmin,
            cannot_adjust_after_entry: !facility.allowUpdatingReservationAfterEntry,
            click_target: clickTarget,
            city: city.slug,
            country: reservation.city.countryCode,
            currency: currencyType.toLowerCase(),
            email: email || '',
            ...(event && {event_id: event.id}),
            is_reservation_change: isReservationChange,
            location: 'Parking Pass', // As opposed to "Legacy Parking Pass"
            parking_spot_id: facility.id,
            parking_spot_name: facility.title,
            parking_type: reservationType,
            rental_end_time_local: ends.format(TimeUtils.FULL_DATETIME_STRING),
            rental_end_time_utc: ends.toISOString(),
            rental_lead_time: starts.diff(now.tz(timezone), 'minutes'),
            rental_length: isMonthly ? null : ends.diff(starts, 'minutes'),
            rental_start_time_local: starts.format(
                TimeUtils.FULL_DATETIME_STRING
            ),
            rental_start_time_utc: starts.toISOString(),
            rental_id: rentalId,
            scanned_in_time: Boolean(entryTimestamp),
            scanned_out_time: Boolean(exitTimestamp),
            scan_in_time: entryTimestamp,
            scan_out_time: exitTimestamp,
            state: facility.state,
            ...getUserLocation(),
            user_logged_in: status === UserUtils.AUTH_STATE.USER,
            reservation_status: reservationStatus,
        };

        SegmentUtils.track({
            event: 'Parking Pass Click',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 2,
                    },
                },
            },
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - parkingPassClick',
        });
    }
}
